import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY, TRZBY, EXISTUJICI_ZAPUJCKY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

const edit = {
	// TopCard
	PujcovnaId: null as number | null,
	VozidloId: null as number | null,
	VozidloRzv: null as string | null,
	Stanovst: null as string | null,
	VozidlopaId: null as number | null,

	// ZakladniInformace
	UzivatelvozId: null as number | null,
	UzivatelvozIdText: null as string | null,
	UzivatelvozOsobniCis: null as string | null,
	TechnikvozId: null as number | null,
	TechnikvozIdText: null as string | null,
	TechnikvozOsobniCis: null as string | null,
	LimitpujDate: null as string | null,
	LimitpujKm: null as number | null,
	PredvVozidloPrp: null as boolean | null,

	Priorita: null as number | null,
	NakladyJdn: null as number | null,
	NakladyJdnProvoz: null as number | null,
	Pc: null as number | null,
	DphSzbOzn: null as number | null,
	KmSazba: null as number | null,
	VolneKmDen: null as number | null,

	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Oznaceni: null as string | null,

	VozidlodruhPzn: null as number | null,
	KarostypPzn: null as number | null,
	PalivoPzn: null as number | null,
	PrevodtypPzn: null as number | null,
	PouzitelPzn: null as number | null,

	KmStav: null as number | null,
	PristspKmStav: null as number | null,
	PcKatalog: null as number | null,
	PcProdej: null as number | null,
	PcPevna: null as number | null,

	VyrobekvozOzn: null as string | null,
	ModelRok: null as string | null,
	Vin: null as string | null,
	BarvaKod: null as string | null,
	TpNr: null as string | null,

	StkDat: null as string | null,
	StkplatDat: null as string | null,
	EmiseDat: null as string | null,
	Objem: null as number | null,
	Vykon: null as number | null,

	VozidlopaVariaList: null as number[] | null,
	Text: null as string | null,

	// Poznamka
	CmrozvrhId: null as number | null,
	Podminpa: null as string | null,
	Oznam: null as string | null,
	Memo: null as string | null,
	VstupPracIdText: null as string | null,
	VstupPracId: null as number | null,
	VstupDat: null as string | null,
	EditPracIdText: null as string | null,
	EditPracId: null as number | null,
	EditDat: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Pujcovna: [],
		DphSazba: [],
		Priorita: [],
		VozidloDruh: [],
		KaroserieTyp: [],
		Palivo: [],
		PrevodovkaTyp: [],
		Pouzitelnost: [],
		ProvozovnaId: [],
		VyrobekvozOzn: [],
		Stanoviste: [],
		VozidlopaVaria: [],
		Cmrozvrh: [],
	},
	edit,
	localState: {
		SazbyDph: null as any, // TODO: type.
	},
	depTableNames,
	depTableSettings: {
		[TRZBY]: { filter(state) { return { VozidlopaId: state.edit.VozidlopaId }; } },
		[EXISTUJICI_ZAPUJCKY]: { filter(state) { return { VozidlopaId: state.edit.VozidlopaId }; } },
	},
	extraActions: {
		[types.actions.VOZIDLO_SELECT_ZMENA]: async ({ commit, state, dispatch }) => {
			if (state.edit.VozidloId) {
				const { data } = await apiProvider.zmenaVozidla(state.edit.VozidloId);
				commit(types.mutations.VOZIDLO_SELECT_ZMENA, data);
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[types.mutations.VOZIDLA_PUJCOVNY_VOZIDLO_MAPPER](state, { data }) {
			state.edit.VozidloId = data.value;
			state.edit.VozidloRzv = data.spz;
			state.edit.Vin = data.karoserieNr;
			state.edit.Text = data.text;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.UzivatelvozId = data.value;
			state.edit.UzivatelvozIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.UzivatelvozOsobniCis = data.osobniCis;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_TECHNIK_SELECT_MAPPER](state, { data }) {
			state.edit.TechnikvozId = data.value;
			state.edit.TechnikvozIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.TechnikvozOsobniCis = data.osobniCis;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
		[types.mutations.VOZIDLO_SELECT_ZMENA](state, data) {
			state.edit = {
				...state.edit,
				VyrobekvozOzn: data.VyrobekvozOzn,
				Vin: data.Vin,
				ModelRok: data.ModelRok,
				BarvaKod: data.BarvaKod,
				TpNr: data.TpNr,
				StkDat: data.StkDat,
				StkplatDat: data.StkplatDat,
				EmiseDat: data.EmiseDat,
				Objem: data.Objem,
				Vykon: data.Vykon,
				VozidloRzv: data.VozidloRzv,
			};
		},
	},
	props: {
		mode: null,
	},
});
